import { Fragment } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import countries, { countryCodeOptions } from "../../../../../data/countries";
import { useTranslation } from "react-i18next";
import LegalIdentifiers from "../../../../../components/Forms/LegalIdentifiers";

function DetailsTab({ customerData, onChangeInput }) {
  const { t } = useTranslation();
  return(
    <Fragment>
      <Row>
        <Col md="4" className="mb-3">
          <Label>{t('contact.firstName')} <span className="text-danger">*</span></Label>
          <Input 
            name="firstname"
            value={customerData.firstname}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
        <Col md="4" className="mb-3">
          <Label>{t('profile.middleName')}</Label>
          <Input 
            name="middlename"
            value={customerData.middlename}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
        <Col md="4" className="mb-3">
          <Label>{t('contact.lastName')}</Label>
          <Input 
            name="lastname"
            value={customerData.lastname}
            onChange={(e) => onChangeInput(e.target)}
          />
        </Col>
      </Row>

      <Row>
        <Col md="6" className="mb-3">
          <Label>{t('common.type')} </Label>
          <Input type="select" name="type" value={customerData.type} onChange={(e) => onChangeInput(e.target)}>
            <option value="">{t('common.select')}</option>
            <option value="individual">{t('crm.individual')}</option>
            <option value="company">{t('crm.company')}</option>
          </Input>
        </Col>
        {customerData.type === 'company' && 
          <Col md="6" className="mb-3">
            <Label>{t('settings.companyNameLabel')} </Label>
            <Input 
              name="company_name" 
              value={customerData.company_name} 
              onChange={(e) => onChangeInput(e.target)} 
            />
          </Col>
        }
      </Row>

      <Row>
        <Col md="6" 
        className="mb-3">
          <Label>{t('common.email')} </Label>
          <Input 
            name="primary_email" 
            value={customerData.primary_email} 
            onChange={(e) => onChangeInput(e.target)} 
          />
        </Col>
        <Col md="6" className="mb-3">
          <Label>{t('common.phone')} </Label>
          <div className="d-flex gap-2">
            <div style={{ width: 140, flexShrink: 0 }}>
              <Select
                options={countryCodeOptions}
                value={countryCodeOptions.find((o) => o.value === customerData.country_code) || null}
                onChange={(selected) =>
                  onChangeInput({ name: 'country_code', value: selected ? selected.value : '' })
                }
                styles={SelectCustomStyles}
              />
            </div>
            <Input
              type="tel"
              name="primary_phone"
              placeholder={t('common.phoneNumberPlaceholder')}
              value={customerData.primary_phone}
              onChange={(e) => onChangeInput(e.target)}
            />
          </div>
        </Col>
      </Row>

      <FormGroup>
        <Label>{t('common.country')} </Label>
        <Select
          name="country"
          value={countries.map(c => ({ value: c.slug, label: c.name })).find(o => o.value === customerData.country) || null}
          onChange={(selected) => onChangeInput({ name: 'country', value: selected ? selected.value : '' })}
          options={
            countries.map((country) => (
              { value: country.slug, label: country.name }
            ))
          }
          styles={SelectCustomStyles}
        />
      </FormGroup>

      <LegalIdentifiers data={customerData} onChangeInput={onChangeInput} />

      <FormGroup>
        <Label>{t('common.notes')} </Label>
        <Input
          type="textarea"
          name="notes"
          value={customerData.notes}
          onChange={(e) => onChangeInput(e.target)}
          rows="4"
        />
      </FormGroup>
    </Fragment>
  );
}

export default DetailsTab;